import { Trans, useTranslation } from 'react-i18next';

import { Body1 } from '@myphx-engineering/phx-design-system';

import { PolicyTextButton } from '../../../../components';
import { CheckboxField } from '../../../../components/form-fields/CheckboxField';
import { CONSTANTS } from '../../../../constants';
import type { useSignUpForm } from '../../../sign-up/use-sign-up-form';

export type PolicyCheckboxProps = {
    form: ReturnType<typeof useSignUpForm>['form'];
};
export const PolicyCheckbox = ({ form }: PolicyCheckboxProps) => {
    const { t } = useTranslation();

    const termsConditionsText = t('policyFooter.termsAndConditions');
    const privacyPolicyText = t('policyFooter.privacyPolicy');
    const waPrivacyNoticeText = t('policyFooter.WAPrivacyNotice');

    const policyCheckboxLabel = (
        <Body1>
            <Trans
                i18nKey="lilly.signUpPage.policyOptIn"
                components={{
                    1: (
                        <PolicyTextButton
                            linkText={termsConditionsText}
                            linkType={CONSTANTS.termsConditionsLink}
                            eventName="LILLY-T&C"
                        />
                    ),
                    2: (
                        <PolicyTextButton
                            linkText={privacyPolicyText}
                            linkType={CONSTANTS.privacyPolicyLink}
                            eventName="LILLY-PP"
                        />
                    ),
                    3: (
                        <PolicyTextButton
                            linkText={waPrivacyNoticeText}
                            linkType={CONSTANTS.waPrivacyNoticeLink}
                            eventName="LILLY-WPN"
                        />
                    ),
                }}
            />
        </Body1>
    );

    return (
        <CheckboxField
            form={form}
            page="SIGNUP"
            field="policyOptIn"
            label={policyCheckboxLabel}
        />
    );
};
